// extracted by mini-css-extract-plugin
module.exports = {"header":"Form_header__2xKzd","newDoc_group":"Form_newDoc_group__1LDS4","newDoc_checkbox":"Form_newDoc_checkbox__2Pi0o","newDoc_label":"Form_newDoc_label__1ONxl"};